import { swePnr } from '@/utils/validators'
import SugarDate from 'sugar'

const RulesMixin = {
  // eslint-disable-next-line object-shorthand
  data: function () {
    return {
      rules: {
        notEmpty: value => (Array.isArray(value) && value.length > 0) || 'Måste anges.',
        required: value => Boolean(value) || this.$i18n.t('errors.rules.required'),
        uploadSize: value => !value || value.size < 100 || this.$i18n.t('errors.rules.upload-size'),
        requiredIf: (condition,value) => (condition && Boolean(value)) || this.$i18n.t('errors.rules.required'),
        pwdLength: value => (!value || value.length >= 8) || this.$i18n.t('errors.rules.pwdlength'),
        pwdMatch: (v1,v2)  => v1===v2 || this.$i18n.t('errors.rules.pwdmatch'),
        integer: value => (!value || Number.isInteger(Number.parseInt(value))) || this.$i18n.t('errors.rules.integer'),
        hasLength: (len, value) => {
          return (!value || (value.length && value.length === len)) || this.$i18n.t('errors.rules.length', {length: len})
        },
        hasDepartments: value => {          
          return (!value || (!value.length == 0)) || this.$i18n.t('errors.rules.departmentArray')
        },
        orgnr: value => {
          return (!value || (value.length && value.length === 11)) || this.$i18n.t('errors.rules.orgnr')
        },
        pnr13: value => {
          return (!value || (value.length && value.length === 13)) || this.$i18n.t('errors.rules.prn13')
        },
        confirmCode: value => {
          return (!value || (value.length && value.length === 4)) || this.$i18n.t('errors.rules.confirmCode')
        },
        swePnr: value => (!value || swePnr(value)) || this.$i18n.t('errors.rules.swepnr'),
        phone: value => {
          const pattern = /^([+](\d{1,3})\s?)?((\(\d{3,5}\)|\d{2,5})([\s-]*)?)\d{5,9}$/
          return (!value || pattern.test(value)) || this.$i18n.t('errors.rules.phone')
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return (!value || pattern.test(value)) || this.$i18n.t('errors.rules.email')
        },
        employmentRate: value => {
          const parsedValue = parseFloat(value)
          return (parsedValue >= 1.0 && parsedValue <= 100.0) || this.$i18n.t('errors.rules.employmentRate') 
        },
        isMinor: (value = '') => {
          const birthDate = SugarDate.Date(String(value).slice(0, 8));
          const age = birthDate.yearsAgo();
          return age < 18
        }
      }
    }
  }

}

export default RulesMixin
